import { render, staticRenderFns } from "./AppUserCard.vue?vue&type=template&id=48da126d&scoped=true&"
import script from "./AppUserCard.vue?vue&type=script&lang=js&"
export * from "./AppUserCard.vue?vue&type=script&lang=js&"
import style0 from "./AppUserCard.vue?vue&type=style&index=0&id=48da126d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48da126d",
  null
  
)

export default component.exports